/*
 * GlobalPhoneDialerButton — the phone dialer's header quick-action button.
 *
 * Lives INLINE in the top app-bar Toolbar (App.tsx), beside the AI / Search /
 * Notification icons — the real "quick action console" (Mike: "make a phone
 * dial option at the top … the header is their quick action console"; and the
 * earlier floating FAB was "annoying to mess with behind it"). Toolbar-native
 * (color="inherit"), NOT a floating fixed/portal element, so it scrolls with
 * the static app-bar instead of staying frozen over content.
 *
 * When telephony isn't configured the button stays VISIBLE but DISABLED (greyed)
 * with a reason tooltip — Mike: "it shouldn't be invisible just grayed out."
 */
import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { useAuth } from '../../../contexts/AuthContext';
import { useTwilio } from '../../../contexts/TwilioContext';

const GlobalPhoneDialerButton: React.FC = () => {
  const { user } = useAuth();
  const { configured, openDialer, isDialerOpen } = useTwilio();

  // Only hide pre-auth. When telephony is off we still SHOW the button, greyed.
  if (!user) return null;

  return (
    <Tooltip title={configured ? 'Open dialer' : 'Calling isn’t set up (connect Twilio in Settings)'}>
      {/* span wrapper so the Tooltip still fires while the button is disabled */}
      <span style={{ marginLeft: 4, display: 'inline-flex' }}>
        <IconButton
          aria-label={configured ? 'Open dialer' : 'Dialer unavailable — calling not set up'}
          color="inherit"
          disabled={!configured}
          onClick={() => { if (configured && !isDialerOpen) openDialer(); }}
          sx={{ '&:hover': { bgcolor: 'action.hover' }, color: isDialerOpen ? 'primary.main' : 'inherit' }}
        >
          <PhoneIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default GlobalPhoneDialerButton;
